import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const MainContainer = styled(Flex)`
  position: fixed;
  bottom: 0;
  right: 0;
  width: calc(100% - 246px);
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  z-index: 99;
`;
